/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Directory_Submit_Enrich_Result_OverallInputs */

const en_directory_submit_enrich_result_overall = /** @type {(inputs: Directory_Submit_Enrich_Result_OverallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Overall ${i?.score}`)
};

const zh_directory_submit_enrich_result_overall = /** @type {(inputs: Directory_Submit_Enrich_Result_OverallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`综合 ${i?.score} 分`)
};

/**
* | output |
* | --- |
* | "Overall {score}" |
*
* @param {Directory_Submit_Enrich_Result_OverallInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_result_overall = /** @type {((inputs: Directory_Submit_Enrich_Result_OverallInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Result_OverallInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_result_overall(inputs)
	return zh_directory_submit_enrich_result_overall(inputs)
});
export { directory_submit_enrich_result_overall as "directory.submit.enrich.result.overall" }